import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Pagination } from 'src/app/common/models/pagination';
import { Pagable } from 'src/app/lem/models/common/pagable';
import { PaginatedResponse } from 'src/app/lem/models/common/paginated-response';
import { CompaniesDepartment } from 'src/app/lem/models/departments/departments';

@Component({
  selector: 'app-dipartimenti-list',
  templateUrl: './dipartimenti-list.component.html',
  styleUrls: ['./dipartimenti-list.component.css']
})
export class DipartimentiListComponent implements OnInit {
  @Input() resetCurrentPage: boolean;
  @Input() dipartments : PaginatedResponse<CompaniesDepartment>;
  @Output() edit = new EventEmitter<CompaniesDepartment>();
  @Output() delete = new EventEmitter<CompaniesDepartment>();
  @Input() pagable:Pagable;
  @Output() refreshEvent: EventEmitter<Pagination> = new EventEmitter<Pagination>();

  constructor(private route: Router ,private activatedRoute : ActivatedRoute ) { }



  ngOnInit() {

  }

  onEdit(companyDepartment : CompaniesDepartment) {
    this.edit.emit(companyDepartment);
  }
  onDelete(companyDepartment : CompaniesDepartment) {
    this.delete.emit(companyDepartment);
  }
  onInfo(companyDepartment : CompaniesDepartment) {
    this.route.navigate(["./detail"], {relativeTo: this.activatedRoute});
  }



}
